import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class GlassTube extends React.Component {
  constructor(props){
    super(props)
  }
  
  componentWillMount() {
    this.props.createGlassTube({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
      <ul>
        <li
          id={"GlassTube_"+this.props.id}
          tabIndex={0}
          className={'GlassTube dropTarget'}>
          <p aria-hidden="true" style={{display: 'none'}} className="label">{this.props.defaultProps.tooltipLabel}</p>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

GlassTube.propTypes = {
  createGlassTube: PropTypes.func,
};

GlassTube.defaultProps = {};
